import { render, staticRenderFns } from "./landlordManagement.vue?vue&type=template&id=0ac45f7e&scoped=true&"
import script from "./landlordManagement.vue?vue&type=script&lang=js&"
export * from "./landlordManagement.vue?vue&type=script&lang=js&"
import style0 from "./landlordManagement.vue?vue&type=style&index=0&id=0ac45f7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac45f7e",
  null
  
)

export default component.exports